import { useReducer } from "react";
import React, { useRef, useEffect, useState, useCallback, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Select from "react-select";
import GLOBALS from "../../utils/Globals";
import { destOptions } from "../../data/data";
import Iframe from "react-iframe";
import axios from "axios";
import { RotatingLines, Bars } from "react-loader-spinner";
import Footer from "../Footer/Footer";
import Button from "react-bootstrap/Button";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Popup from "reactjs-popup";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "animate.css/animate.min.css";
import Form from "react-bootstrap/Form";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "../AgGrid/styles.css";
//import DynamicForm from "./DynamicForm";
import { getUserProfileAction } from "../../redux/slices/users/usersSlice";
import MappingComponent from "../../components/Mapping/MappingComponent.tsx";
import formSchema from "./formSchema.json"; // Import your schema

import formSchema2 from "./formSchema2.json"; // Import your schema

import TabsWithThumbnails from "./TabsWithThumbnails.tsx"
//import { extractValuesFromPDF } from './extractValues';

import {
  LicenseManager,
  RowApiModule,
  HighlightChangesModule,
  ValidationModule,
} from "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-material.css";
import ButtonRenderer from "../AgGrid/ButtonRenderer";
import statusRenderer from "../AgGrid/statusRenderer";
import Carousel from 'react-bootstrap/Carousel';

// const files = [
//   { id: 1, name: 'PDF 1', thumbnail: 'https://fastly.picsum.photos/id/997/200/300.jpg?hmac=NeXq5MvhpKvGEq_X3jULp2C3Lg-8IQK8bdtnyJeXDIQ' },
//   { id: 2, name: 'PDF 2', thumbnail: 'https://fastly.picsum.photos/id/997/200/300.jpg?hmac=NeXq5MvhpKvGEq_X3jULp2C3Lg-8IQK8bdtnyJeXDIQ' },
//   { id: 3, name: 'PDF 3', thumbnail: 'https://fastly.picsum.photos/id/997/200/300.jpg?hmac=NeXq5MvhpKvGEq_X3jULp2C3Lg-8IQK8bdtnyJeXDIQ' },
// ];

const baseURLGetOpenAIQueuePDF =
  process.env.REACT_APP_ENV === "PROD"
    ? GLOBALS.PROD.baseURLGetOpenAIQueuePDF
    : GLOBALS.DEV.baseURLGetOpenAIQueuePDF;

const options = [];
const names = [];
const colourOptions = [];

function ImportOCR() {

  
  const gridRef = useRef();
  const [rowData, setRowData] = useState();
  //const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const [openAIPDF, setOpenAIPDF] = useState();

  const toastError = () => toast.error("Please select a destination");

  const toastSuccess = () => toast.success("Data and Destination Verified!");

  const toastCancelImport = () => toast.warning("Cancelling Import");

  const toastPublished = () => toast.success("Publishing Successful!");

  var username = "";
  var url = "http://localhost:8080/example/test.html?dest=";

  const [job, setJob] = React.useState(null);
  const [url_mod, setUrl_Mod] = React.useState(null);
  const { isOpen, onOpen, onClose } = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  var isDisabled = true;

  const [loading, setLoading] = useState(false);
  const [userChoice, setUserChoice] = useState("");
  const [schemas, setSchemas] = useState(null);
  const [totJobs, setTotJobs] = useState(null);
  const [numDocs, setNumDocs] = useState(null);
  const [email, setEmail] = useState(null);
  const [modalShow, setModalShow] = React.useState(false);
  const [formFields, setFormFields] = useState([]);
  const handleNavigate = () => {
    setModalShow(false);
    navigate("/");
  };

  const handleFormSubmit = (formData) => {
    console.log("Form Data:", formData);
  };

  const { error, profile } = useSelector((state) => state?.users);

  const dispatch = useDispatch();  

  useEffect(() => {

    dispatch(getUserProfileAction());

    console.log(profile.user.email)

    const myNewAsyncMethod = async () => {
          // async request
          const response = await axios.get(baseURLGetOpenAIQueuePDF + "/" + profile.user.email)
    
          // logic after async request
          if (response) {
            console.log(response.data)
            setOpenAIPDF(response.data)
            return;
          }
      }
    
      // trigger new async function.
      myNewAsyncMethod(); 

    }, [dispatch]);

  function getDest(choice) {
    console.log(choice);
    if (choice.length === 0) {
      setUserChoice("");
    } else {
      setUserChoice(choice);
    }
  }

  function cancelImport() {
    toastCancelImport();
  }

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      editable: false,
      enableCellChangeFlash: true,
    };
  });

  const gridOptions = {
    autoSizeStrategy: {
      type: "fitCellContents",
    },
  };
  const [colDefs, setColDefs] = useState([
    {
      field: "line",
      flex: 1,
    },
    {
      field: "GTIN",
      filter: "agTextColumnFilter",
      editable: true,
    },
    {
      field: "status",
      cellRenderer: statusRenderer,
      width: 20,
    },
    {
      field: "status",
      cellClassRules: {
        "red-cell": (p) => p.value === "failed",
        "green-cell": (p) => p.value === "success",
      },
      filter: "agTextColumnFilter",
    },
    {
      field: "actions",
      headerName: "Actions",
      cellRenderer: ButtonRenderer,
    },
  ]);

  const updateRows = useCallback((gtin, row) => {
    const rowNode = gridRef.current.api.getDisplayedRowAtIndex(row);

    //console.log(rowNode)

    if (gtin == "its null") {
      rowNode.setDataValue("status", "failed");
    }
    if (rowNode.data.GTIN == gtin) {
      rowNode.setDataValue("status", "success");
    }

    //console.log(rowNode);
  }, []);

  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: false,
    };
  }, []);

  //console.log(openAIPDF.data[0].files.length)

  return (
    <div>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <br></br>
            <h1 className="text-xl font-semibold text-gray-900">
              Import PDF Data
            </h1>
            Total number of files - {openAIPDF.data[0].files.length}
            <br></br>
            <br></br>
            <TabsWithThumbnails files={openAIPDF.data[0].files} />
            <br></br>
            
            <Footer />
          </div>
        </div>
        <hr></hr>
      </div>
    </div>
  );
}

export default ImportOCR;
